<template>
  <p>
    Enter your postcode below to see the estimated delivery date for your order.
  </p>

  <form
    class="form delivery-estimator__form"
    @submit.prevent="handleFormSubmit"
  >
    <label class="field field--combo">
      <div class="input">
        <input
          v-model.trim="postcode"
          type="text"
          class="input__element"
          placeholder="Enter postcode"
        />
      </div>
      <div class="input input--submit">
        <Button type="submit" transparent>SEE DELIVERY DATE</Button>
      </div>
    </label>
    <div v-if="v$.postcode.$dirty" class="input__response">
      <ul>
        <li v-for="error of v$.postcode.$errors" :key="error.$uid">
          {{ error.$message }}
        </li>
      </ul>
    </div>
  </form>

  <template v-if="estimatedDeliveryDate">
    <p class="delivery-estimator__results">
      {{ deliveryService }} - {{ estimatedDeliveryDate }}
    </p>
  </template>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Button from "@/components/Button.vue";
import format from "date-fns/format";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "DeliveryEstimator",
  components: {
    Button,
  },
  props: {
    weight: {
      type: Number,
      default: 0.2,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      deliveryService: null,
      estimatedDeliveryDate: null,
    };
  },
  computed: {
    ...mapState("app", ["userCountry", "deliveryEstimate"]),
    ...mapGetters("app", ["userPostCode"]),
    postcode: {
      get() {
        return this.userPostCode;
      },
      set(value) {
        this.setUserPreferences({
          key: "userPostCode",
          value,
        });
      },
    },
  },
  watch: {
    userCountry(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (oldVal === null && newVal !== null) {
        if (this.postcode) {
          this.handleFormSubmit();
        }
      }
    },
  },
  methods: {
    ...mapActions("app", ["setUserPreferences", "getDeliveryEstimate"]),
    async handleFormSubmit() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      await this.getDeliveryEstimate({
        weight: this.weight,
      });

      const { estimated_delivery_date, service_type_name } =
        this.deliveryEstimate;

      this.estimatedDeliveryDate = format(
        new Date(estimated_delivery_date),
        "eeee do MMMM yyyy"
      );

      this.deliveryService = service_type_name;
    },
  },
  validations() {
    return {
      postcode: { required },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form";

.delivery-estimator {
  &__form {
    margin: 6px 0 0;
  }

  &__results {
    margin-top: 10px;
  }
}
</style>
